import { jsx as _jsx } from "react/jsx-runtime";
// components
import { StyledDivider } from "./divider.styles";
export function Divider({ alignment = "horizontal", inverted, }) {
    return _jsx(StyledDivider, { alignment: alignment, inverted: inverted });
}
